import {
  types as rs,
  sectionsSortedByDef,
  checkSectionsFulfilled,
} from 'earn-ts';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BsPlusLg, BsDash } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/app/store';
import Button from 'src/components/Order/Button';
import FoodImage from 'src/components/Order/FoodImage';
import Header from 'src/components/Order/HeaderComponent';
import QuantityItem from 'src/components/Order/QuantityItem';
import { RadioButton } from 'src/components/Order/RadioButton';
import TextField from 'src/components/Order/TextField';
import {
  confirmDraftSet,
  decrementFood,
  draftSetComment,
  hasOptions,
  incrementFood,
  onEditMenu,
  openGroupOptions,
  setDraftSet,
} from 'src/reducer/order/orderReducer';
import { pickName } from 'src/utils';
import _ from 'lodash';
import PopupGroupOption from 'src/components/Order/PopupGroupOption';
import { useIsAvailable } from 'src/hook/useIsAvailable';
import { toast } from 'react-toastify';

let counter = 1;

/* The screen editing a set, contains sections */
export default function ListFoodSet() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {
    selectedSet,
    optionGroup,
    dataSelectedMenus,
    isEditMenu,
    shopId,
    foodSet,
    draftSet,
    menuDef,
    fullOrder,
    optionsPage,
  } = useAppSelector(state => state.order);

  const { language } = useTranslation(['main']).i18n;

  const handleBack = () => {
    navigate(-1);
    dispatch(onEditMenu(false));
  };

  const isAvailable = useIsAvailable();

  /*
  // for testing, dunno if need to keep
  useEffect(() => {
    dispatch(getMenuThunk('4'));
    dispatch(updateShopId('4'));
  }, []);
   */

  //function check validate
  const [sectionError, setSectionError] = useState('');
  const [messageErrorSection, setMessageErrorSection] = useState('');
  const [messageError, setMessageError] = useState('');
  const setSections = useMemo(() => {
    return sectionsSortedByDef(
      Object.keys(selectedSet.sections),
      selectedSet.sections,
    );
  }, [selectedSet]);

  const foodItemsGroupBySetSection = useMemo(() => {
    if (menuDef == null) return {};

    return Object.fromEntries(
      Object.entries(selectedSet.sections).map(([secId, secDef]) => [
        secId,
        {
          listId: secDef.list,
          listDef: menuDef?.lists[secDef.list],
          foodDefs:
            menuDef?.lists[secDef.list]?.items
              ?.map(it => ({
                id: it.food,
                def: menuDef.foods[it.food],
                avail: isAvailable(menuDef.foods[it.food]),
                quantity:
                  draftSet?.sections[secId]?.filter(
                    it2 => it2.food_id === it.food,
                  )?.length ?? 0,
              }))
              ?.filter(({ avail }) => [null, 'sold_out'].includes(avail)) ?? [],
        },
      ]),
    );
  }, [selectedSet, menuDef, draftSet]);
  console.log('re-render ListFoodSet ', counter++);

  const isFulfilled = useMemo(() => {
    if (draftSet == undefined) return true;
    return checkSectionsFulfilled(draftSet, selectedSet).length === 0;
  }, [selectedSet, draftSet]);

  const checkMaxQuantity = (sectionId: string, foodId: string) => {
    const maxQuatity = selectedSet.sections[sectionId].max;
    const quantity = draftSet?.sections?.[sectionId]?.length ?? 0;
    if (maxQuatity && maxQuatity !== 1 && !(quantity < maxQuatity)) {
      setSectionError(sectionId);
      setMessageErrorSection('Total quantity of food in section is maximum.');
      return true;
    }
    return false;
  };
  /** @param onlyRequired if enabled, dont open drawer if no required option */
  const checkShouldOpenDrawer = (
    sectionId: string,
    foodId: string,
    onlyRequired: boolean,
  ) => menuDef && hasOptions(menuDef, foodId, onlyRequired);
  const checkIsShowItem = (sectionId: string, foodId: string) => {
    return (
      foodSet?.secId === null ||
      foodSet?.secId != sectionId ||
      foodSet?.value == foodId
    );
  };
  const incrementQuantity = (sectionId: string, foodId: string) => {
    dispatch(incrementFood({ sectionId, foodId }));
    const maxQuantity = checkMaxQuantity(sectionId, foodId);
    const isOpenDrawer = checkShouldOpenDrawer(sectionId, foodId, false);
    if (isOpenDrawer && !maxQuantity) gotoOptionsPage(sectionId, foodId);
  };

  const decrementQuantity = (sectionId: string, foodId: string) => {
    setMessageErrorSection('');
    setMessageError('');
    dispatch(decrementFood({ foodId, sectionId }));
  };

  const decrementQuantitySet = () => {
    dispatch(
      setDraftSet({
        ...draftSet!,
        quantity: Math.max(1, (draftSet?.quantity ?? 0) - 1),
      }),
    );
  };

  const incrementQuantitySet = () => {
    dispatch(
      setDraftSet({ ...draftSet!, quantity: (draftSet?.quantity ?? 0) + 1 }),
    );
  };

  const [openActionSheetOption, setOpenActionSheetOption] =
    useState(!!optionsPage);

  const gotoOptionsPage = (sectionId: string, foodId: string) => {
    dispatch(openGroupOptions({ foodId, sectionId }));
    setOpenActionSheetOption(true);
  };

  const getConditionText = (min: number, max: number): string => {
    if (min > 0) {
      return (
        'Required' +
        (max > 1 ? `, select ${min === max ? max : min + '-' + max} items` : '')
      );
    }
    return `Optional ${!!max ? `up to ${max}` : ''}`;
  };

  const handleConfirm = async () => {
    dispatch(confirmDraftSet(0));
    setMessageErrorSection('');
    toast.success('Added to order success !', {
      position: 'top-center',
      autoClose: 1000,
      hideProgressBar: true,
      theme: 'colored',
    });
    navigate(-1);
  };

  const debouncedHandleSetComment = useCallback(
    _.debounce((comment: string) => {
      dispatch(draftSetComment(comment));
    }, 700),
    [dispatch],
  );

  const [isTitleFixed, setIsTitleFixed] = useState(false);
  const title = useMemo(() => {
    const base = pickName(selectedSet, language);
    if (foodSet?.value != null) {
      const extra = pickName(menuDef?.foods?.[foodSet.value]!, language);
      return `${extra}`;
    } else return base;
  }, [selectedSet, foodSet, language]);

  useEffect(() => {
    const handleScroll = () => {
      const titleElement = document.getElementById('scrollingTitle');
      const headerElement = document.getElementById('headerTitle');
      if (titleElement && headerElement) {
        const titleRect = titleElement.getBoundingClientRect();
        setIsTitleFixed(titleRect.top <= 0);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div>
      <div
        className={`top-0 z-20 left-0 fixed px-[15px] pt-[10px] w-full scroll-smooth font-medium ${
          isTitleFixed ? 'bg-white shadow-md' : ''
        }`}>
        <Header
          title={`${isTitleFixed ? title : ''}`}
          isShowBack={true}
          onPressBack={handleBack}
          isShowMenu={false}
          isHideHomeIcon={true}
        />
      </div>
      {foodSet && (
        <FoodImage
          food={{ kind: 'set', def: foodSet! }}
          defaultUri="/food_white.jpg"
          alt="food_white"
          className="object-cover w-full h-[240px] shadow-sm mb-2"
        />
      )}
      <div
        id="scrollingTitle"
        className="font-medium grow w-full overflow-y-auto">
        <div className="flex flex-row-reverse justify-between w-full mb-3">
          <div className="flex flex-col w-full items-start justify-between px-[15px]">
            <p
              id="headerTitle"
              className="text-[20px] text-left mt-1 font-bold">
              {title}
            </p>
            <p className="text-[16px] text-left">{''}</p>
            <p className="text-[16px] text-left">{''}</p>
          </div>
        </div>
        <div className="mt-4 w-full">
          {setSections
            .map((it): [string, rs.MenuSection] => [
              it,
              selectedSet.sections[it],
            ])
            .map(([sectionId, sectionDef]) => (
              <div className="w-full flex flex-col mb-6" key={sectionId}>
                <div className="text-[16px] text-left capitalize mb-2 px-[15px]">
                  {pickName(sectionDef, language) || sectionId}
                </div>
                <p className="text-[12px] text-left text-shadow-5 font-normal border-b-[1px] border-shadow-3 pb-2 px-[15px]">
                  {getConditionText(sectionDef.min!, sectionDef.max!)}
                </p>
                {foodItemsGroupBySetSection[sectionId].foodDefs.map(
                  (item, index) => {
                    const showItem = checkIsShowItem(sectionId, item.id);
                    if (!showItem) return <div key={index} />;
                    return (
                      <label htmlFor={`set ${sectionId} ${index}`} key={index}>
                        <span
                          className="flex flex-row justify-between items-center py-4 border-b-[1px] border-shadow-3 border-solid bg-white px-[15px]"
                          key={index}
                          onClick={e => incrementQuantity(sectionId, item.id)}>
                          <p className="text-[16px] font-normal">
                            {pickName(item.def, language)}
                            {item.avail == 'sold_out' && (
                              <span> - SOLD OUT</span>
                            )}
                          </p>
                          {item.avail == null && (
                            <div className="flex items-center">
                              {item.def.option_groups.length &&
                              item.quantity > 0 ? (
                                <Button
                                  className="font-medium ml-3 mr-3 px-3 text-[14px]"
                                  variant="secondary"
                                  label="Edit"
                                  onClick={e => {
                                    e.stopPropagation();
                                    gotoOptionsPage(sectionId, item.id);
                                  }}
                                />
                              ) : (
                                <></>
                              )}
                              {sectionDef.max === 1 ? (
                                <RadioButton
                                  id={`set ${sectionId} ${index}`}
                                  name={sectionId}
                                  value={item.id}
                                  //onChange={() => 0} // not needed
                                  checked={item.quantity > 0}
                                  readOnly={true}
                                />
                              ) : (
                                <QuantityItem
                                  id={`set ${sectionId} ${index}`}
                                  value={item.quantity}
                                  name={sectionId}
                                  handleIncrease={() => {}} // click on the whole area already handles it
                                  handleDecrease={e => {
                                    e.stopPropagation();
                                    decrementQuantity(sectionId, item.id);
                                  }}
                                />
                              )}
                            </div>
                          )}
                        </span>
                      </label>
                    );
                  },
                )}
                {sectionError === sectionId && (
                  <div className="ml-3 text-[14px] text-left mt-2 text-red-500">
                    {messageErrorSection}
                  </div>
                )}
              </div>
            ))}
        </div>
        {/* <div className="mt-5 w-full px-[15px]">
          <p className="text-[16px] text-left mb-2">Remarks (Optional)</p>
          <TextField/>
        </div> */}
        {menuDef?.enable_remarks && (
          <div className="text-[16px] w-full text-left mb-3">
            <p className="font-bold text-left pt-4 mt-2 mb-2 px-[15px]">
              Remarks (Optional)
            </p>
            <TextField
              className="font-normal w-full bg-[#fff] px-[15px] border-y-[1px] border-shadow-3 py-4 focus:ring-0 focus:outline-none"
              placeholder={pickName(selectedSet, language)}
              onChange={e => debouncedHandleSetComment(e.target.value)}
              defaultValue={draftSet?.comment ?? ''}
            />
          </div>
        )}
      </div>
      <>
        <div className="ml-3 text-[14px] text-left mt-5 text-red-500">
          {messageError}
        </div>
        <div className="border-t-[1.5px] border-solid border-shadow-2 bg-white pt-4 pb-4 fixed bottom-0 left-0 w-full px-[15px] flex flex-row items-center justify-between">
          <div className="font-medium flex flex-row items-center justify-between mr-5">
            <BsDash
              className="border-black border-2 rounded-full stroke-1 text-black"
              fontSize={20}
              onClick={decrementQuantitySet}
            />
            <div className="text-[28px] px-6 text-primary">
              {draftSet?.quantity}
            </div>
            <BsPlusLg
              className="border-black border-2 rounded-full stroke-1 text-black"
              fontSize={20}
              onClick={incrementQuantitySet}
            />
          </div>
          <Button
            className={`font-medium px-3 py-2 text-[16px] w-[130px] ${
              !isFulfilled ? 'bg-shadow-3' : ''
            }`}
            label={isEditMenu ? 'Update Order' : 'Add to Order'}
            disabled={!isFulfilled}
            onClick={handleConfirm}
          />
        </div>
      </>
      <PopupGroupOption
        openActionSheet={openActionSheetOption}
        setOpenActionSheet={setOpenActionSheetOption}
      />
    </div>
  );
}
